 <template>
  <div class="home" style="padding-top:10px">
    <!--<div>-->
    <!--patientName：{{patientName}}-->
    <!--</div>-->
    <!--<div>-->
    <!--formId：{{formId}}-->
    <!--</div>-->
    <!--<div>-->
    <!--formName：{{formName}}-->
    <!--</div>-->
    <!--<div>-->
    <!--projectId：{{projectId}}-->
    <!--</div>-->
    <a-row>
      <a-col :span="18">
        <label style="font-size: 16px">
          录音
        </label>
      </a-col>
      <a-col :span="6" style="text-align: right">
          <span v-show="isRecording()">
            <label style="margin-right: 10px">{{currentRecordingTimeStr}}</label>
            <!--结束录音-->
           <a-badge dot>
               <a-icon type="audio" theme="twoTone"  @click="stopCurrentRecorder('1')" class="icon-btn"/>
            </a-badge>
        </span>
        <!--开始录音-->
        <a-icon type="audio"   @click="startCurrentRecorder()" class="icon-btn" v-show="!isRecording()" />
      </a-col>
    </a-row>
    <br/>
    <a-modal
      title="保存录音文件"
      :width="600"
      :visible="submitVisible"
      :confirmLoading="submitLoading"
      @ok="handleSubmit"
      @cancel="handleCancel">
      <a-spin :spinning="submitLoading">
        <a-form-model layout="horizontal" :model="formData" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}" ref="ruleForm" :rules="rules">
          <a-form-model-item
            prop="totalTime"
            label="时长">
            {{formData.totalTime}}秒
          </a-form-model-item>
          <a-form-model-item
            prop="name"
            label="文件名">
            <a-input placeholder="请输入文件名" v-model="formData.name" />
          </a-form-model-item>
          <a-form-model-item
            label="描述">
            <a-textarea :rows="3" placeholder="请输入描述" v-model="formData.description" />
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </a-modal>
    <a-modal
      title="数据采集"
      :width="300"
      :visible="tipVisible"
      @ok="tipHandleOk"
      @cancel="tipVisible = false">
      是否开始数据采集？
    </a-modal>
  </div>
</template>

<script>
  import { postAction,uploadAction } from '@/api/manage'
  // const lamejs = require('lamejs')
  import baseRules from '@/constants/baseRules'
  import moment from 'moment'

  // // 绑定事件-打印的是当前录音数据
  // recorder.onprogress = function(params) {
  //   // console.log('--------------START---------------')
  //   // console.log('录音时长(秒)', params.duration);
  //   // console.log('录音大小(字节)', params.fileSize);
  //   // console.log('录音音量百分比(%)', params.vol);
  //   // console.log('当前录音的总数据([DataView, DataView...])', params.data);
  //
  //   // console.log('--------------END---------------')
  // }
  export default {
    name: 'Recorder',
    props:{
      patientName:{
        default:''
      },
      formName:{
        default:''
      },
      formId:{
        default:''
      },
      projectId:{
        default:''
      },
      patientId:{
        default:''
      },
      recordingTip:{
        default:false
      }
    },
    inject:['startRecorder','stopRecorder','isRecording','startRecorder2','stopRecorder2','isRecording2'],
    data () {
      return {
        formItemId:'',
        formItemName:'',
        error:null,
        tipVisible:false,
        formData:{},
        rules:{
          name:[baseRules.required]
        },
        submitLoading:false,
        submitVisible:false,

        fileUploadUrl: "/sys/common/upload",
        currentFileInfo:{},
        recordingTimeInfo:{
          start:0,
          end:0,
        },
        recordingTimeInfo2:{
          start:0,
          end:0,
        },
        currentRecordingTimeStr:'00:00',
        callBack:null,
        recorder:window.myRecorder
      }
    },
    mounted(){
      this.tipView()
    },
    watch:{
      recordingTip(){
        this.tipView()
      },
    },
    computed:{
    },
    methods: {
      tipView(){
        if(this.recordingTip){
          this.tipVisible = true
        }
      },
      /**
       *  录音的具体操作功能
       * */
      // 开始录音
      startCurrentRecorder () {
        this.startRecorder(() => {
          this.recordingTimeInfo.start = new Date().getTime()
          this.timer = setInterval(() => {
            this.currentRecordingTimeStr =this.formatSeconds((new Date() -  this.recordingTimeInfo.start )/ 1000)
          }, 1000)
        })
        this.startRecorder2(() => {
          this.recordingTimeInfo2.start = new Date().getTime()          
        })
      },

      // 结束录音
      stopCurrentRecorder (isEnd) {
        if (this.timer) clearInterval(this.timer)
        this.currentRecordingTimeStr='00:00'
        this.recordingTimeInfo.end = new Date().getTime()
        // 结束录音后的业务逻辑
        this.handleStopService(isEnd)
        // this.destroyRecorder()
      },

      /**
       * 结束录音后的业务逻辑
       */
      handleStopService(isEnd){
        if(!this.recordingTimeInfo.start){
          return
        }
        const getMp3 = this.stopRecorder()

        // 提供录音上传功能
        const totalTime = ((this.recordingTimeInfo.end -  this.recordingTimeInfo.start )/ 1000) || -1;//获取时长
        // 此处获取到blob对象后需要设置fileName满足当前项目上传需求，其它项目可直接传把blob作为file塞入formData
        // let blob = this.recorder.getWAVBlob();//获取 WAV 数据
        // const newbolb = new Blob([blob], { type: 'audio/wav' })
        // this.debugInfo = newbolb
        // const suffix = 'wav'
        getMp3.then(([buffer, blob]) => {
          const suffix = 'mp3'
          const fileName = `${this.patientName}_${this.formName}_${this.formItemName}_${moment().format('YYYY-MM-DD HH:mm:ss') }`
          //获取当时时间戳作为文件名
          const fileOfBlob = new File(buffer,`${this.formId}_${new Date().getTime()}.${suffix}`)
          // 表单数据
          const formData = {
            name:fileName,
            suffix:suffix,
            totalTime:parseInt(totalTime),
            serveId:this.formId,
            serve2Id:this.formItemId,
            projectId:this.projectId,
            type:'3',
            size: fileOfBlob.size
          }
          this.formData = formData

          // console.log('wav',wav)
          this.currentFileInfo = {file:fileOfBlob,totalTime:totalTime}
          if(isEnd=='1'){
            this.submitVisible = true
          }else{
            this.handleSubmit(isEnd)
          }
          // do what ever you want with buffer and blob
          // Example: Create a mp3 file and play

        }).catch((e) => {
          console.log(e);
        });

      },
      tipHandleOk(){
        this.tipVisible = false
        this.startCurrentRecorder()
      },
      handleSubmit(isEnd){
        //继续录音
        if(isEnd!='1'){
          this.startCurrentRecorder()
        }
        const fileOfBlob = this.currentFileInfo.file
        const formData = new FormData()
        formData.append('file', fileOfBlob)
        formData.append('biz',`/${this.projectId}/${this.patientId}/${this.formId}`)
        this.submitLoading = true
        uploadAction(this.fileUploadUrl,formData).then((res) => {
          if(res.success){
            this.formData.path = res.message

            postAction('/project/projectFile/add',this.formData).then(res=>{
              if(this.callBack){
                this.callBack()
              }
              this.$emit('submitAction')

              this.handleCancel()
            }).finally(()=>{
              this.submitLoading = false
            })
          }else{

          }
        }).catch(e=>{
          this.$message.error(e)
          this.error = e
          this.submitLoading = false
        });
      },
      handleCancel(){
        this.submitVisible = false
        this.currentFileInfo = {}
        this.formData = {}
        this.callBack = null
      },
      formatSeconds(value) {
        //  秒
        let second = parseInt(value)
        //  分
        let minute = 0
        //  如果秒数大于60，将秒数转换成整数
        if (second > 60) {
          //  获取分钟，除以60取整数，得到整数分钟
          minute = parseInt(second / 60)
          //  获取秒数，秒数取佘，得到整数秒数
          second = parseInt(second % 60)
        }
        let result = `${minute<10?'0'+minute:minute}:${second<10?'0'+second:second}`
        return result
      },
      /**
       * 保存的时候主动结束录音
       */
      submitFormHandle(formItem,callBack){
        this.callBack = null;
        // 如果不在录音就结束录音
        if(!this.isRecording()){
          if(callBack){
            callBack()
          }
        }
        else{
          this.callBack = callBack
          this.formItemId = formItem.id
          this.formItemName = formItem.name
          this.stopCurrentRecorder()
        }
      },
      // 保存表单完整录音
      saveAllRecorder2(){
        if(!this.isRecording2()){
          return
        }
        this.recordingTimeInfo2.end = new Date().getTime()
        const getMp3 = this.stopRecorder2()

        // 提供录音上传功能
        const totalTime = ((this.recordingTimeInfo2.end -  this.recordingTimeInfo2.start )/ 1000) || -1;//获取时长
        
        getMp3.then(([buffer, blob]) => {
          const suffix = 'mp3'
          const fileName = `${this.patientName}_${this.formName}_all_${moment().format('YYYY-MM-DD HH:mm:ss') }`
          //获取当时时间戳作为文件名
          const fileOfBlob = new File(buffer,`${this.formId}_${new Date().getTime()}.${suffix}`)
          // 表单数据
          const formData = {
            name:fileName,
            suffix:suffix,
            totalTime:parseInt(totalTime),
            serveId:this.formId,
            projectId:this.projectId,
            type:'3',
            size: fileOfBlob.size
          }          
          const uploadData = new FormData()
          uploadData.append('file', fileOfBlob)
          uploadData.append('biz',`/${this.projectId}/${this.patientId}/${this.formId}`)
          
          uploadAction(this.fileUploadUrl,uploadData).then((res) => {
            if(res.success){
              formData.path = res.message

              postAction('/project/projectFile/add',formData).then(res=>{                
                this.$emit('submitAction')
              }).finally(()=>{
                
              })
            }else{
              this.$message.error(res.message)
            }
          }).catch(e=>{
            this.$message.error(e)
            this.error = e
          });
        }).catch((e) => {
          console.log(e);
        });
      },
      closeFormHandle(){
        this.stopRecorder()
        this.stopRecorder2()
      },
    },
    beforeDestroy(){
      // 结束录音并自动保存
      this.stopRecorder()
      this.stopRecorder2()
    }
  }
</script>

<style lang='less' scoped>
  .icon-btn{
    font-size: 20px;
  }
</style>